export default __webpack_public_path__ + "static/media/homebackground.da298376.jpg";